<mat-accordion>
  <mat-expansion-panel [expanded]="true" (opened)="panelOpenState = true" (closed)="panelOpenState = false">

    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="header">
          <i class="cml-fw cml-lg cml-calendar" [attr.active-color]="'cml-active-red'"></i>Účetní období
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="form-container" class="form">

      <div class="navigate-buttons">
        <button mat-button (click)="newUcetniObdobiModal()"><i class="cml-fw cml-lg cml-plus" [attr.active-color]="'cml-active-blue'">
        </i><span>Nové účetní období</span></button>
      </div>

      <div class="scroll">
        <table *ngIf="dataSource.length > 0" mat-table [dataSource]="dataSource" class="mat-elevation-z1">

          <ng-container *ngFor="let col of tableColumns" matColumnDef="{{col.name}}">
            <th mat-header-cell *matHeaderCellDef> {{col.title}} </th>

            <span *ngIf="col.type == 'date'">
              <td mat-cell *matCellDef="let element" [matTooltip]="element[col.name] |czDatePipe" matTooltipShowDelay="1000" matTooltipPosition="above">
                {{element[col.name] | czDatePipe}}
              </td>
            </span>

            <span *ngIf="col.type == ''">
              <td mat-cell *matCellDef="let element" [matTooltip]="element[col.name]" matTooltipShowDelay="1000" matTooltipPosition="above">
                {{element[col.name]}}
              </td>
            </span>
          </ng-container>

          <ng-container matColumnDef="dokladRada">
            <th mat-header-cell *matHeaderCellDef> Dokladová řada</th>
            <td mat-cell *matCellDef="let element">
              <button mat-button (click)="navigateToDokladovaRada(element.kod)">Přejít</button>
            </td>
          </ng-container>

          <ng-container matColumnDef="uctovyRozvrh">
            <th mat-header-cell *matHeaderCellDef> Účtový rozvrh </th>
            <td mat-cell *matCellDef="let element">
              <button mat-button (click)="navigateToUctovyRozvrh(element)">Přejít</button>
            </td>
          </ng-container>

          <ng-container matColumnDef="vypocetVykazu">
            <th mat-header-cell *matHeaderCellDef> Výpočet výkazu </th>
            <td mat-cell *matCellDef="let element">
              <button mat-button (click)="navigateToVypocetVykazu(element)">Přejít</button>
            </td>
          </ng-container>

          <ng-container matColumnDef="akce">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let i = index">
              <button mat-button (click)="delete(i)">
                <i class="cml-fw cml-lg cml-trash-o" [attr.active-color]="'cml-active-black'">
                </i></button>
            </td>
          </ng-container>

          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let i = index">
              <button mat-button (click)="edit(i)">
                <i class="cml-fw cml-lg cml-edit-pen" [attr.active-color]="'cml-active-black'">
                </i></button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr class="tbody-row" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
    <mat-hint class="mat-hint-empty-data" *ngIf="dataSource.length <= 0">UJ neobsahuje žádné účetní období</mat-hint>
  </mat-expansion-panel>
</mat-accordion>
